import type { CSSProperties } from 'react';
import type { TaskPriority } from '../../lib/tasksApi';
import { translate } from '../../lib/i18n';

// Locale-aware label maps (CLE-278). Each `label` is a live getter that resolves
// through the i18n dictionary on read, so consumers reflect the active locale
// without re-creating these constants on every language toggle.
function priorityOption(value: TaskPriority): { value: TaskPriority; label: string } {
  return {
    value,
    get label() {
      return translate(`tasks.priority.${value}`);
    },
  };
}

export const PRIORITY_OPTIONS: { value: TaskPriority; label: string }[] = [
  priorityOption('NONE'),
  priorityOption('URGENT'),
  priorityOption('HIGH'),
  priorityOption('MEDIUM'),
  priorityOption('LOW'),
];

// Tailwind color classes per priority for badges.
export const PRIORITY_BADGE: Record<TaskPriority, string> = {
  URGENT: 'bg-red-100 text-red-800',
  HIGH: 'bg-orange-100 text-orange-800',
  MEDIUM: 'bg-yellow-100 text-yellow-800',
  LOW: 'bg-blue-100 text-blue-800',
  NONE: 'bg-gray-100 text-gray-600',
};

/**
 * Badge styling for a configurable status (CLE-DASH): the DB stores a hex
 * accent color, rendered as a translucent background + solid text so any
 * user-chosen color reads well on the light theme.
 */
export function statusBadgeStyle(color: string): CSSProperties {
  return { backgroundColor: `${color}22`, color };
}

export function formatDueDate(due: string | null): string {
  if (!due) return '—';
  return new Date(due).toLocaleDateString('ro-RO');
}
